export default "__VITE_ASSET__BlsH$vYf__"